import { render, staticRenderFns } from "./ImgCarousel.vue?vue&type=template&id=53be3ab8&"
import script from "./ImgCarousel.vue?vue&type=script&lang=js&"
export * from "./ImgCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ImgCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports